export default {
    gallery: null,
    index: 0,
    irSaving: false,
    irSavingData: false,
    irLoadingReportData: false,
    widgetStructure: false
}
